// How far above the purchased quantity an institution may go before it is blocked.
export const OVERAGE_ALLOWANCE = 10

/** The count at which the entitlement actually stops allowing more. */
export const getEffectiveEntitlementLimit = (entitlementValue: number) =>
  entitlementValue + OVERAGE_ALLOWANCE

export const canAddMoreMembers = (entitlementValue: number, currentCount: number | null) =>
  typeof currentCount === 'number'
    ? currentCount < getEffectiveEntitlementLimit(entitlementValue)
    : false

export const canAddMoreReportingForms = (entitlementValue: number, currentCount: number | null) =>
  typeof currentCount === 'number'
    ? currentCount < getEffectiveEntitlementLimit(entitlementValue)
    : false
